import { Trans } from '@lingui/macro';
import {
  ActionIcon,
  Box,
  Button,
  Divider,
  Flex,
  Grid,
  LoadingOverlay,
  Stack,
  Text,
} from '@mantine/core';
import dayjs from 'dayjs';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'tabler-icons-react';

import { TimeBlock } from '../../components/train-route-info/train-route-info';
import { UiCard } from '../../components/ui/ui-card/ui-card';
import { useOrders } from '../../domains/cabinet/features/orders/orders.provider';
import { UserTimeZoneNotify } from '../../domains/tz-notify/tz-notify';
import { MainSideMenu } from '../../features/main-side-menu/main-side-menu';
import { getNameLocal } from '../../lib/local/get-title';
import { useLocal } from '../../lib/local/use-local';
import { routeCabinet } from '../../router/routes';

import styles from './my-tickets.page.module.css';

export const MyTicketsPage = observer(() => {
  const [lang] = useLocal();
  const { getOrdersRequest, ordersStore } = useOrders();
  const isLoading = getOrdersRequest.isWaitingForLoad;

  const navigate = useNavigate();

  return (
    <div className={styles.container}>
      <header className={styles.header}>
        <div className={styles.backButton}>
          <ActionIcon
            variant="transparent"
            radius="50%"
            size="40px"
            bg="transparent"
            onClick={() => navigate(routeCabinet.path)}
          >
            <ArrowLeft size={24} strokeWidth={2} color="white" />
          </ActionIcon>
        </div>
        <div className={styles.routeTitle}>
          <h1 className={styles.headerTitle}>
            <Trans>Мои билеты</Trans>
          </h1>
        </div>
        <div className={styles.mainSideMenu}>
          <MainSideMenu />
        </div>
      </header>

      <main className={styles.main}>
        <Box pos="relative" mih={200}>
          <LoadingOverlay visible={isLoading} />

          {ordersStore.tickets.length === 0 && !isLoading && (
            <UiCard>
              <Trans>Билеты пока что отсутствуют</Trans>
            </UiCard>
          )}

          {ordersStore.tickets.length > 0 && (
            <Stack spacing="sm">
              <UserTimeZoneNotify />

              {ordersStore.tickets.map((ticket) => (
                <UiCard key={ticket.id}>
                  <Stack spacing="sm">
                    <Flex justify="space-between" align="center">
                      <Text span size="sm" fw={700}>
                        <Trans>Дата заказа</Trans>:
                      </Text>
                      <Text span size="sm">
                        {dayjs(ticket.date).format('DD.MM.YYYY HH:mm')}
                      </Text>
                    </Flex>
                    {ticket.stationFrom && ticket.stationTo && (
                      <Grid align="center" justify="center" gutter={10}>
                        <Grid.Col span="content">
                          <TimeBlock
                            target={getNameLocal(lang, ticket.stationFrom)}
                            date={new Date(ticket.departureTime)}
                          />
                        </Grid.Col>
                        <Grid.Col span="auto">
                          <Divider my={4} />
                        </Grid.Col>
                        <Grid.Col span="content">
                          <TimeBlock
                            target={getNameLocal(lang, ticket.stationTo)}
                            date={new Date(ticket.arrivalTime)}
                            direction="end"
                          />
                        </Grid.Col>
                      </Grid>
                    )}

                    <Button
                      size="lg"
                      onClick={() =>
                        navigate(
                          routeCabinet.TICKET.buildPath({ id: ticket.orderId })
                        )
                      }
                    >
                      <Trans>Показать билет</Trans>
                    </Button>
                  </Stack>
                </UiCard>
              ))}
            </Stack>
          )}
        </Box>
      </main>
    </div>
  );
});
